import React from "react";
import Image from "next/image";
import {
  descriptionBody,
  descriptionHeader,
  descriptionWrapper,
  image,
  imageWrapper,
  wrapper
} from "./OrderItAgain.css";
import { DeprecatedUISharedButton } from "packages/ui-shared/components/Button/Button";
import { navigate } from "@shared/utils.routing";
import { useScreenViewport } from "lib/checkViewport";
import {
  useTrackElementClicked,
  useTrackElementViewed
} from "packages/membership/tracking";
import type { BaseTrackingValues } from "packages/membership/tracking/types";
import { useLocale } from "hooks";

const baseTrackingValues: BaseTrackingValues = {
  target: "order_it_again_on_search",
  location: "order_it_again_on_search"
};

export const OrderItAgain: React.FC = () => {
  const locale = useLocale();
  const { isMobile } = useScreenViewport();
  const { ref } = useTrackElementViewed({
    ...baseTrackingValues,
    payload: { locationDetails: "search_menu" }
  });
  const { elementClicked } = useTrackElementClicked({
    ...baseTrackingValues
  });

  const navigateToOIAPage = () => {
    const contentRedirectUrl =
      locale === "en-GB"
        ? "account/favourites/order-it-again"
        : "/account/favourites/order-it-again";

    navigate("/account/favourites/order-it-again");
    elementClicked({
      details: "browse_my_past_orders",
      locationDetails: "search_menu",
      contentUrl: window ? `${window.location.href}${contentRedirectUrl}` : ""
    });
  };

  return (
    <div className={wrapper} ref={ref}>
      <div className={imageWrapper}>
        <Image
          src="/images/membership/homepage/just-for-you.jpeg"
          alt="oia-image"
          fill={isMobile}
          width={!isMobile ? 228 : undefined}
          height={!isMobile ? 228 : undefined}
          className={image}
        />
      </div>
      <div className={descriptionWrapper}>
        <h3 className={descriptionHeader}>Ready for a restock?</h3>
        <p className={descriptionBody}>
          Reorder your past picks in just a few clicks…
        </p>
        <DeprecatedUISharedButton
          variant="tertiary"
          type="button"
          ariaLabel="Browse"
          fullWidth={isMobile ?? false}
          handleClick={navigateToOIAPage}
        >
          Browse my past orders
        </DeprecatedUISharedButton>
      </div>
    </div>
  );
};
